/**
 * rc130 — Zona horaria del ISP para formatear fechas en el admin.
 *
 * Fuente: `sistema.timezone` (Ajustes › Datos del ISP), que llega con el
 * branding público (GET /api/v1/branding). Mientras no cargue, se usa el
 * default de México. Los helpers de formato son síncronos, por eso es una
 * variable de módulo y no un hook.
 */
export const TZ_DEFAULT = "America/Mexico_City";
let _tz = TZ_DEFAULT;

export function getTz(): string {
  return _tz;
}

export function setTz(tz: string | null | undefined): void {
  const v = (tz || "").trim();
  if (!v) return;
  try {
    // valida que el navegador conozca la zona
    new Intl.DateTimeFormat("es-MX", { timeZone: v });
    _tz = v;
  } catch {
    /* zona desconocida para este navegador: conservar la anterior */
  }
}
